import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  standalone: false
})
export class HeaderComponent {
  @Input() title = 'Agenda tu visita';
  @Input() subtitle: string | undefined;
  @Input() alignStyle = {
    'align-content': 'flex-start',
    'align-items': 'flex-start'
  };
  @Input() iconStyle = {
    'width': '60px',
  };
}
